var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShower(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-4{fill:none;stroke:#1d1d1b}.cls-1{stroke-miterlimit:10;stroke-width:1.98px}.cls-3,.cls-4{stroke-linejoin:round;stroke-width:1.7px;stroke-linecap:round}.cls-4{stroke-dasharray:4.27 4.27}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.75 140.19h39.29V19.52H62.22M14.91 32.56V19.52h47.31M54.2 140.19H14.91V39.94"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.1 58.58h4.25v12.13l18.3 27a1.76 1.76 0 0 1-1.76 1.75H55.05a1.76 1.76 0 0 1-1.76-1.75l18.3-27V58.58h9.1",
    style: {
      strokeWidth: "1.7px",
      strokeLinejoin: "round",
      fill: "none",
      stroke: "#1d1d1b"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.96 107.31v2.13"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M94.96 113.71v23.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.96 139.35v2.12M79.98 107.31v2.13"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M79.98 113.71v23.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M79.98 139.35v2.12M64.99 107.31v2.13"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M64.99 113.71v23.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.99 139.35v2.12"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: "1.7px",
      strokeMiterlimit: 10,
      fill: "none",
      stroke: "#1d1d1b"
    },
    d: "M79.76 58.6V40.63H15.25"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShower);
export default __webpack_public_path__ + "static/media/shower.a04bdf94.svg";
export { ForwardRef as ReactComponent };